import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
var axios_intsace_get_fbp_ess = get_axios_instance(api_variables.SERVICE_FBP_DECLARATION_ESS)
var axios_intsace_get_fbp_all_data_ess = get_axios_instance(api_variables.SERVICE_FBP_DECLARATION_ALL_DATA_ESS)
var axios_intsace_post_ess = get_axios_instance(api_variables.SERVICE_FBP_DECLARATION_DECLARE_ESS)
const _pk_name = "id";

const state = {
    entityWiseData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};
const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record
    }
};
const mutations = {
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },
    setRecord: (state, payload) => {
        state.record = payload.record;
    }
};
const actions = {
    async fetchAll({ commit }, payload) {
        //console.log("i am action new one", payload)
        try {
            commit("setFetching", true);
            let res = await axios_intsace_get_fbp_ess.get(``, {
                params:
                {
                    employee_id: payload.employee_id,
                    le_id: payload.le_id,
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("setRecord", [res.data.payload, payload]);
                //console.log("i am action new one", res)
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
    async fetchAllData({commit},payload){
        try{
            commit('setFetching',true);
            let res = await axios_intsace_get_fbp_all_data_ess.get('',{
                params:{
                    employee_id:payload.employee_id,
                    le_id:payload.le_id,
                    financial_year: payload.financial_year,
                }
            });
            commit('setFetching',false);
            if(res.status ==200){
                commit('setRecord',[res.data.payload,payload]);

            }
            return res
        } catch(err){
            throw errorHandler(err.message)
        }
    },
    async create({ commit }, payload) {
        //console.log("i am eneterd",payload )
        try {
            commit("setSaving", true);
            let res = await axios_intsace_post_ess.put("/", payload);
            commit("setSaving", false);
            if (res.status == 201) {
                commit("addEntity", [res.data.payload, payload.data.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

